export function getLimitLockType(licenseType, trialState) {
    if (trialState === 'ACTIVE') {
        return 'readonly';
    }
    if (licenseType === 'PREPAID') {
        return 'hidden';
    }
    return undefined;
}
